<template>
    
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Produksi</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer />
                    <v-btn color="primary" dark class="mb-2" small @click="createProduction" v-if="$store.state.currentPagePriv.create">
                        <v-icon small>mdi-plus</v-icon>
                        Add
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                {{ (item.status) ? 'Closed' : 'Open' }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewItem(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            headers: [
                { text: 'Prod No', value: 'prod_no' },
                { text: 'Tanggal Produksi', value: 'production_date' },
                { text: 'Status', value: 'status' },
                { text: 'Remarks', value: 'remarks' },
                { text: '', value: 'actions' }
            ],
            items: []
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        async initialize() {
            let response = await this.$store.dispatch('massproduction/getObjs');
            this.items = response;
        },
        viewItem(item) {
            this.$router.push({
                path: '/mass-production/' + item.prod_no,
                query: { readonly: '1' },
            });
        },
        editItem(item) {
            this.$router.push('/mass-production/'+ item.prod_no);
        },
        createProduction() {
            this.$router.push('/mass-production/new');
        }
    }
}
</script>